module.exports = __webpack_public_path__ + "img/report1.fbaafc4.png";